import "antd/lib/space/style";
import _Space from "antd/lib/space";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import ROUTES from 'constants/Routes';
import { useRouter } from 'next/router';
import React from 'react';

var SubHeaderChannel = function SubHeaderChannel(_ref) {
  var channelUUID = _ref.channelUUID,
      _ref$current = _ref.current,
      current = _ref$current === void 0 ? 'post' : _ref$current;
  var router = useRouter();

  var goToPage = function goToPage() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'post';

    if (page !== current) {
      switch (page) {
        case 'post':
          router.push(ROUTES.business.getChannelPage(channelUUID));
          break;

        case 'analitics':
          router.push(ROUTES.business.getChannelAnaliticsPage(channelUUID));
          break;

        case 'settings':
          router.push(ROUTES.business.getChannelSettingsPage(channelUUID));
          break;

        default:
          break;
      }
    }
  };

  return /*#__PURE__*/_jsx("div", {
    className: "channelRoutes ".concat(current),
    children: /*#__PURE__*/_jsxs(_Space, {
      size: "large",
      children: [/*#__PURE__*/_jsx("div", {
        onClick: function onClick() {
          return goToPage('post');
        },
        className: "linkPost",
        children: /*#__PURE__*/_jsx("div", {
          className: "navbar",
          children: "Post"
        })
      }), /*#__PURE__*/_jsx("div", {
        onClick: function onClick() {
          return goToPage('analitics');
        },
        className: "linkAnalitics",
        children: /*#__PURE__*/_jsx("div", {
          className: "navbar",
          children: "Analytics"
        })
      }), /*#__PURE__*/_jsx("div", {
        onClick: function onClick() {
          return goToPage('settings');
        },
        className: "linkSettings",
        children: /*#__PURE__*/_jsx("div", {
          className: "navbar",
          children: "Settings"
        })
      })]
    })
  });
};

export default SubHeaderChannel;